import emitter from 'element-ui/src/mixins/emitter'

export default {
    mixins: [emitter],
    props: {
        showTitle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    computed: {
        theme() {
            return this.$store.state.brpaModule.theme
        }
    },
    watch: {
        '$store.state.brpaModule.theme': {
            handler(newV, oldV) {
                this.drawChart(newV)
            }
        }
    }
}
